export const MAX_AMOUNT_ALLOWED = 9999999999.99;
export const MAX_DIGITS_TOTAL = 12;
